var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"product-tab",class:{ 'is-grey': _vm.isGrey, 'is-active': _vm.show },on:{"click":_vm.toggle}},[_vm._t("click-area")],2),_vm._v(" "),(_vm.show)?_c('div',[_vm._t("toggle-area")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }